import React from 'react';
import linear_loader from '../../assets/gifs/bouncing_loader.gif'
import {PageTransition} from "../../components/layouts/PageTransition";

interface Props {
    small?: boolean
    transparent?: boolean
}

const Loader = ({small, transparent}: Props) => {
    return (
        <PageTransition>
            <div
                className={`w-full mx-auto self-center ${transparent ? '!bg-transparent' : ''} flex flex-col items-center justify-center ${small ? 'min-h-[30vh]' : 'min-h-screen'}`}>

                <img src={linear_loader} width={200} alt="loader"/>

            </div>
        </PageTransition>
    );
};

export default Loader;